import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PlatformFeatureGuardComponent } from './components/platform-feature-guard/platform-feature-guard.component';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [ PlatformFeatureGuardComponent ],
    exports: [ PlatformFeatureGuardComponent ]
})
export class PlatformComponentsModule { }
